import { render, staticRenderFns } from "./AlertMissingWorkerLogo.vue?vue&type=template&id=b45de266&scoped=true&"
import script from "./AlertMissingWorkerLogo.vue?vue&type=script&lang=js&"
export * from "./AlertMissingWorkerLogo.vue?vue&type=script&lang=js&"
import style0 from "./AlertMissingWorkerLogo.vue?vue&type=style&index=0&id=b45de266&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b45de266",
  null
  
)

export default component.exports